import React from 'react';
import Slider from 'react-slick';

// COMPONENTS
import Icon from '../Icon';

// ENUMS
import { Icons } from 'enums';

// INTERFACES
import { INextButton, IPrevButton, ISlickyCarousel } from '../../interfaces/SlickyCarousel.interface';

// STYLES
import { SliderContainer, SlickyCarouselButton } from './styles';

const PrevButton: React.FC<IPrevButton> = ({ prevButtonTitle, prevButtonId, onClick }): JSX.Element => {
  return (
    <SlickyCarouselButton
      id={prevButtonId ?? 'prevBanner'}
      onClick={onClick}
      title={prevButtonTitle ?? 'Retornar ao item anterior'}
    >
      <Icon type={Icons.ARROW_LEFT} />
    </SlickyCarouselButton>
  );
};

const NextButton: React.FC<INextButton> = ({ nextButtonTitle, nextButtonId, onClick }): JSX.Element => {
  return (
    <SlickyCarouselButton
      id={nextButtonId ?? 'nextBanner'}
      onClick={onClick}
      title={nextButtonTitle ?? 'Avançar ao próximo item'}
    >
      <Icon type={Icons.ARROW_RIGHT} />
    </SlickyCarouselButton>
  );
};

const SlickyCarousel: React.FC<ISlickyCarousel> = ({
  nextButtonConfig,
  prevButtonConfig,
  slideHeight,
  slideMarginRight,
  slickClassName = 'slider variable-width',
  dots = false,
  infinite = true,
  centerMode = false,
  slidesToShow = 1,
  slidesToScroll = 1,
  variableWidth = true,
  children
}): JSX.Element => {
  const settings = {
    className: slickClassName,
    dots: dots,
    infinite: infinite,
    centerMode: centerMode,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    variableWidth: variableWidth,
    prevArrow: (
      <PrevButton prevButtonTitle={prevButtonConfig.prevButtonTitle} prevButtonId={prevButtonConfig.prevButtonId} />
    ),
    nextArrow: (
      <NextButton nextButtonTitle={nextButtonConfig.nextButtonTitle} nextButtonId={nextButtonConfig.nextButtonId} />
    ),
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          centerMode: false
        }
      },
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          centerMode: false
        }
      }
    ]
  };
  return (
    <SliderContainer
      slideHeight={slideHeight}
      slideMarginRight={slideMarginRight}
      prevButtonId={prevButtonConfig.prevButtonId}
      nextButtonId={nextButtonConfig.nextButtonId}
    >
      <Slider {...settings}>{children}</Slider>
    </SliderContainer>
  );
};

export default SlickyCarousel;
